import type { FallbackPlatform } from '../api/fallback-api'
import type { PendingConnect } from '../hooks/use-gateway-connect'

/**
 * Read the connect context the server put on the partner's callback URL.
 * Only Facebook and Instagram on Composio are routed through the popup.
 */
export function pendingConnectFromParams(params: URLSearchParams): PendingConnect | null {
  const platform = params.get('platform')
  const gateway = params.get('gateway')
  const externalUserId = params.get('externalUserId')
  if (platform !== 'facebook' && platform !== 'instagram') return null
  if (gateway !== 'composio' || !externalUserId) return null
  return {
    gateway,
    platform: platform as FallbackPlatform,
    externalUserId,
    connectAttemptId: params.get('connectAttemptId') ?? undefined,
    // Instagram is single-account: finalize with select-account, not a Page picker.
    ...(platform === 'instagram' ? { provider: 'instagram' as const } : {}),
  }
}
